import ModalBoxList from './ModalBoxList'

export default ModalBoxList
